export default {
    formInit() {
        return {
            broadcastTitle: "",
            selectedAudience: "default",
            audienceOptions: [
                { value: "default", text: "All Customers" },
                // { value: 1, text: "Segment 1" },
                // { value: 2, text: "Segment 2" }
            ],
            smsEnabled: false,
            smsDescription: "",
            maxSMSDescription: 480,
            pushNotifEnabled: false,
            pushNotifDescription: "",
            maxPushNotifDescription: 480,
            campaignName: "",
            selectedDeviceType: [],
            emailEnabled: false,
            message: "",
            subject: "",
            broadcastVisibility: false,
            scheduledDate: new Date(),
            scheduledTime: {
                HH: "00",
                mm: "00",
                ss: "00"
            }
        };
    }
};
